import { render, staticRenderFns } from "./purorderplanview.vue?vue&type=template&id=fc048930&scoped=true&"
import script from "./purorderplanview.vue?vue&type=script&lang=js&"
export * from "./purorderplanview.vue?vue&type=script&lang=js&"
import style0 from "./purorderplanview.vue?vue&type=style&index=0&id=fc048930&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc048930",
  null
  
)

export default component.exports